import React from 'react';

const Alumnos = () =>{


      return(
          <div>

            <div className='row' style={{paddingTop:50,margin:0}}>

                <div className='col-12 col-md-6' style={{paddingLeft:40}}>
                    <h5 style={{borderLeft:"solid",borderWidth:10,borderColor:"#C4C4C4"}}><b>&nbsp; Ficha para estudiar en esta institución</b></h5>
                    <p style={{paddingLeft:20}}>A partir del <b>7 DE MARZO</b> y hasta el día DEL <b>EXAMEN</b> podrás solicitar tu ficha en las instalaciones, el costo de la ficha es de $ 100.00 Pagar en efectivo.</p>

                    <hr></hr>
                    <h5 style={{borderLeft:"solid",borderWidth:10,borderColor:"#C4C4C4"}}><b>&nbsp; Preguntas frecuentes:</b></h5>
                    
                    <hr></hr>
                    <h5 style={{borderLeft:"solid",borderWidth:10,borderColor:"#C4C4C4"}}><b>&nbsp; Calendario Escolar:</b></h5>

                    <hr></hr>
                    <h5 style={{borderLeft:"solid",borderWidth:10,borderColor:"#C4C4C4"}}><b>&nbsp; Servicios escolares:</b></h5>

                    <hr></hr>
                    <h5 style={{borderLeft:"solid",borderWidth:10,borderColor:"#C4C4C4"}}><b>&nbsp; Becas:</b></h5>
                </div>

                <div className='col-12 col-md-5' style={{height:400}}>
                    <h5 style={{borderLeft:"solid",borderWidth:10,borderColor:"#C4C4C4"}}><b>&nbsp; Requisitos para la obtencion de ficha</b></h5> 
                    <p>
                        <ul>
                            <li>Copia acta de nacimiento</li>
                            <li>Certificado o constancia de secundaria</li>
                            <li>CURP</li>
                            <li>Correo electrónico del alumno</li>
                            <li>Teléfono del alumno</li>
                            <li>pago en efectivo</li>
                        </ul>
                    </p>
                </div>

            </div>
            
          </div>
      )

}

export default Alumnos;